import React, { useState, useEffect } from 'react'
import { toast } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { CreatorsAnchors } from '../../../../store/ducks/anchors'

import api from '../../../../services/api'
import { getPermissions } from '../../../../services/auth'
import { useHistory } from 'react-router'
import { formatDateTimeToRender } from '../../../../utils/functions';

import Render from './RegisterRender'

function Register ({ id }) {
  const history = useHistory()

  const [inputs, setInputs] = useState({})
  const [getLoading, setLoading] = useState(true)
  const [getAncoras, setAncoras] = useState([])

  const dispatch = useDispatch()

  const handleInputChange = (event) => {
    event.persist()
    setInputs(inputs => ({ ...inputs, [event.target.name]: event.target.value }))
  }

  const getInfoForForm = async () => {
    try {
      const findAncoraTaxaFaixa = await api.get(`AncorasTaxasFaixas/ConsultarId?id=${id}`)
      const findAncoras = await api.get('Ancoras/Consultar')
      setInputs(findAncoraTaxaFaixa.data.resposta)
      setAncoras(findAncoras.data.resposta)
    } catch (err) {
      if (err.response.data && err.response.data.resposta[0]) {
        toast.error(err.response.data.resposta[0].message)
      } else {
        toast.error('Detectamos um problema interno! tente novamente em instantes.')
      }
    }
    setLoading(false)
  }

  useEffect(() => {
    dispatch(CreatorsAnchors.changeLastGrid('ancoras-taxas-faixas'))

    const permissions = getPermissions({ moduloId: 1344, permissao: 'Cadastrar' })

    if (permissions) {
      getInfoForForm()
    } else {
      history.push('/app')
    }
  }, [])

  const handleSubmit = async (event) => {
    if (event) {
      event.preventDefault()

      setLoading(true)
      try {
        const response = await api.put('AncorasTaxasFaixas', {
          ...inputs,
          ancoraTaxaFaixaId: parseInt(id),
          ancoraId: parseInt(inputs.ancoraId),
          valorInicial: parseFloat(inputs.valorInicial),
          valorFinal: parseFloat(inputs.valorFinal),
          taxa: parseFloat(inputs.taxa),
          dataInicioCobranca: inputs.dataInicioCobranca ? formatDateTimeToRender(inputs.dataInicioCobranca) : '',
          dataFinalCobranca: inputs.dataFinalCobranca ? formatDateTimeToRender(inputs.dataFinalCobranca) : ''
        })
        if (response.data.status !== 'Inconsistencia') {
          toast.success('Taxas faixas alterada com sucesso!')
        } else {
          if (response.data.resposta[0].key) {
            response.data.resposta.map(resposta => {
              toast.error(resposta.key + ' - ' + resposta.message)
              return null
            })
          } else {
            toast.error('Não foi possível alterar a âncoras taxa faixas!')
          }
        }
      } catch (err) {
        if (err.response.data && err.response.data.resposta[0]) {
          toast.error(err.response.data.resposta[0].message)
        } else {
          toast.error('Detectamos um problema interno! tente novamente em instantes.')
        }
      }
      setLoading(false)
    }
  }

  return <Render
    inputs={inputs}
    getLoading={getLoading}
    handleInputChange={handleInputChange}
    getAncoras={getAncoras}
    onSubmit={handleSubmit}
  />
}

export default Register
